import React from 'react';
import { Switch } from 'react-router-dom';

import { Route, hasPermission } from '@ubisend/pulse-auth';

import { File, NoFile } from '../Pages/index';

const routes = [
  {
    name: 'File Details',
    path: '/files/:sourceId/view/:fileId',
    component: File,
    canAccess: hasPermission('view files')
  },
  {
    name: 'No File',
    component: NoFile,
    canAccess: hasPermission('view files')
  }
];

const FileRouter = () => {
  return (
    <Switch>
      {routes.map((route, key) => (
        <Route
          exact={route.exact ?? true}
          public={false}
          key={key}
          path={route.path}
          canAccess={route.canAccess}
          render={props => <route.component {...props} />}
        />
      ))}
    </Switch>
  );
};

export default FileRouter;
